// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//******** DESARROLLO *****/
// export const environment = {
//   production: false,
//   loginUrl: 'https://snedesa.pvn.gob.pe/Account/Login?ReturnUrl=',
//   loingUrlPortal: 'https://snedesa.pvn.gob.pe//loginPortal?ReturnUrl=https://sigodesa.pvn.gob.pe',
//   gatewayUrl: 'https://apigatewaydesa.pvn.gob.pe',
//   tipoAcceso: '1'
// };

//******** PRODUCCION *****/
export const environment = {
  production: false,
  loginUrl: 'https://webseguridad.pvn.gob.pe/Account/Login?ReturnUrl=',
  loingUrlPortal: 'https://webseguridad.pvn.gob.pe//loginPortal?ReturnUrl=https://sigo.pvn.gob.pe',
  gatewayUrl: 'https://wsgatewaysigo.pvn.gob.pe',
  tipoAcceso: '1'
};

// // //******** QA *****/
// export const environment = {
//   production: false,
//   loginUrl: 'https://webseguridadqa.pvn.gob.pe/Account/Login?ReturnUrl=',
//   loingUrlPortal: 'https://webseguridadqa.pvn.gob.pe//loginPortal?ReturnUrl=https://sigoqa.pvn.gob.pe',
//   gatewayUrl: 'https://wsgatewaysigoqa.pvn.gob.pe',
//   tipoAcceso: '1'
// };

//******** LOCAL ****/
// export const environment = {
//   production: false,
//   loginUrl: 'https://localhost:44328/Account/Login?ReturnUrl=',
//   loingUrlPortal: 'https://localhost:44328//loginPortal?ReturnUrl=https://localhost:44339/autorizaciones/autorizacion-aprob-online',
//   gatewayUrl: 'https://localhost:44351',
//   tipoAcceso: '1'
// };

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
